module.exports = __webpack_public_path__ + "static/media/protocol.8ff628f4.htm";